import { foreignKey, integer, pgTable, primaryKey, text, unique, uuid } from "drizzle-orm/pg-core";
import { relations } from "drizzle-orm";
import { foodCollection } from "../food-collection/food-collection.sql";
import { food, foodMeta } from "../food/food.sql";
import { nutrient } from "../nutrient/nutrient.sql";

export const externalFoodCollection = pgTable("external_food_collection", {
  id: uuid("id")
    .primaryKey()
    .references(() => foodCollection.id),
  slug: text("slug").notNull().unique(),
  // timeLastSynced: utc('time_last_synced'),
});

export const externalNutrientRef = pgTable(
  "external_nutrient_ref",
  {
    nutrientId: uuid("nutrient_id")
      .notNull()
      .references(() => nutrient.id),
    collectionId: uuid("collection_id")
      .notNull()
      .references(() => externalFoodCollection.id),
    externalId: text("external_id").notNull(),
  },
  (t) => [
    primaryKey({ name: "external_nutrient_ref_pk", columns: [t.collectionId, t.externalId] }),
  ],
);

export const externalFoodIdentity = pgTable(
  "external_food_identity",
  {
    foodId: uuid("food_id").notNull(),
    collectionId: uuid("collection_id")
      .notNull()
      .references(() => externalFoodCollection.id),
    externalId: text("external_id").notNull(),
    externalVariant: text("external_variant"),
  },
  (t) => [
    primaryKey({ name: "external_food_identity_pk", columns: [t.collectionId, t.externalId] }),
    foreignKey({
      name: "external_food_identity_food_meta_fk",
      columns: [t.foodId, t.collectionId],
      foreignColumns: [foodMeta.id, foodMeta.collectionId],
    }),
    unique("external_food_identity_unique").on(t.foodId, t.collectionId),
  ],
);

export const externalFoodIdentityRelations = relations(externalFoodIdentity, ({ one }) => ({
  foodMeta: one(foodMeta, {
    fields: [externalFoodIdentity.foodId],
    references: [foodMeta.id],
  }),
  collection: one(externalFoodCollection, {
    fields: [externalFoodIdentity.collectionId],
    references: [externalFoodCollection.id],
  }),
}));

export const externalFoodProvenance = pgTable(
  "external_food_provenance",
  {
    foodId: uuid("food_id").notNull(),
    foodVersion: integer("food_version").notNull(),
    collectionId: uuid("collection_id")
      .notNull()
      .references(() => externalFoodCollection.id),
    externalId: text("external_id").notNull(),
    externalVersion: text("external_version").notNull(),
    importVersion: integer("import_version").notNull(),
    externalName: text("external_name").notNull(),
  },
  (t) => [
    primaryKey({
      name: "external_food_provenance_pk",
      columns: [t.collectionId, t.externalId, t.externalVersion, t.importVersion],
    }),
    foreignKey({
      name: "external_food_provenance_identity_fk",
      columns: [t.foodId, t.collectionId],
      foreignColumns: [externalFoodIdentity.foodId, externalFoodIdentity.collectionId],
    }),
    foreignKey({
      name: "external_food_provenance_food_fk",
      columns: [t.foodId, t.foodVersion],
      foreignColumns: [food.id, food.version],
    }),
  ],
);

export const externalFoodProvenanceRelations = relations(externalFoodProvenance, ({ one }) => ({
  food: one(food, {
    fields: [externalFoodProvenance.foodId, externalFoodProvenance.foodVersion],
    references: [food.id, food.version],
  }),
  collection: one(externalFoodCollection, {
    fields: [externalFoodProvenance.collectionId],
    references: [externalFoodCollection.id],
  }),
}));
